module.exports = __webpack_public_path__ + "img/detail6-1.62bb5f40.png";